import forEach from 'lodash/forEach'
import isObject from 'lodash/isObject'

const getResourceData = response => {
  if (!response?.success || !isObject(response.data)) return null

  const data = response.data
  forEach(Object.entries(data), ([key, value]) => {
    if (value === 'null') {
      delete data[key]
    }
  })
  return data
}

export { getResourceData }
